import {Tooltip} from 'flowbite';

import {userStore} from '@js/stores/userStore';

import I18n from '@js/modules/translations';
import StorageService from '@js/modules/storage';
import AnalyticsService from '@js/modules/analyticsService';


export default class Terrain3DControl {
    constructor(options = {}) {
        this._is3D = false;
        this._mapMax3DStorage = 'map_3d_max_count';

        if (options.showProductModal) {
            this._showProductModal = options.showProductModal;
        }

        if (options.onClick) {
            this._onClick = options.onClick;
        }
    }

    static TEASER_DURATION = 5_000;

    _onClick3DTerrain(event) {
        event.preventDefault();

        // Turning 3D off is always allowed (and cancels a pending teaser revert).
        if (this._is3D) {
            this._clearTeaser();
            this._setThreeD(false);
            return;
        }

        const limit = userStore.featureFlags.map_3d_max_count;

        // Limited plan (non-Explorer): the flag carries a numeric cap. Explorer has no
        // cap -> the feature is free.
        if (this._showProductModal && limit) {
            const used = StorageService.getItem(this._mapMax3DStorage) || 0;

            // Teaser already consumed -> go straight to the paywall, consistently on the
            // first click, without re-enabling 3D.
            if (used >= limit) {
                this._showProductModal('map_3d_max_count');
                return;
            }

            // First time: give a short 3D teaser, then revert and show the paywall.
            StorageService.setItem(this._mapMax3DStorage, used + 1);
            this._setThreeD(true);
            AnalyticsService.track3DViewClick();

            this._teaserTimeout = setTimeout(() => {
                this._setThreeD(false);
                this._showProductModal('map_3d_max_count');
            }, Terrain3DControl.TEASER_DURATION);

            return;
        }

        // Explorer / unlimited: normal toggle on.
        this._setThreeD(true);
        AnalyticsService.track3DViewClick();
    }

    _setThreeD(state) {
        this._is3D = state;

        if (this._onClick) {
            this._onClick(state);
        }
    }

    _clearTeaser() {
        if (this._teaserTimeout) {
            clearTimeout(this._teaserTimeout);
            this._teaserTimeout = undefined;
        }
    }

    _showTooltip() {
        const tooltipElement = document.getElementById('map-3d-tooltip');
        const tooltipTrigger = document.getElementById('map-3d-button');

        if (tooltipElement && tooltipTrigger) {
            new Tooltip(tooltipElement, tooltipTrigger, {
                placement: 'left',
                triggerType: 'hover'
            });
        }
    }

    _createIcon() {
        this._container = document.createElement('div');
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group map-3d-control';

        this._button = document.createElement('button');
        this._button.id = 'map-3d-button';
        this._button.className = 'maplibregl-ctrl-3d-terrain';
        this._button.title = '3D Terrain';
        this._button.ariaLabel = '3D Terrain';

        this._icon = document.createElement('span');
        this._icon.className = 'maplibregl-ctrl-icon';
        this._icon.textContent = '3D';

        this._tooltip = document.createElement('div');
        this._tooltip.id = 'map-3d-tooltip';
        this._tooltip.className = 'absolute invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip z-tooltip dark:bg-gray-700';
        this._tooltip.role = 'tooltip';
        this._tooltip.textContent = I18n.t('js.maps.toolbar.route_type.tooltip');
        this._tooltipArrow = document.createElement('div');
        this._tooltipArrow.className = 'tooltip-arrow';
        this._tooltipArrow.setAttribute('data-popper-arrow', '');
        this._tooltip.appendChild(this._tooltipArrow);

        this._button.appendChild(this._icon);
        this._container.appendChild(this._button);
        this._container.appendChild(this._tooltip);

        this._button.addEventListener('click', this._onClick3DTerrain.bind(this));

        return this._container;
    }

    onAdd(/* map */) {
        // this._map = map;

        setTimeout(() => {
            this._showTooltip();
        }, 300);

        return this._createIcon();
    }

    onRemove() {
        this._clearTeaser();

        this._button.removeEventListener('click', this._onClick3DTerrain.bind(this));

        this._container.parentNode.removeChild(this._container);

        // this._map = undefined;
    }
}
